import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import router from '@router'
import store from '@store'
import common from '@utils/common'
import globalCop from '@components'
import 'element-ui/lib/theme-chalk/index.css'
import '@assets/css/element.scss'
import '@assets/css/public.scss'
import '@router/guard'

//设置为 false 以阻止 vue 在启动时生成生产提示。
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(common);
Vue.use(globalCop);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
